import * as React from 'react'
import { ReactElement } from 'react'
import InvoiceForm from '../../../components/Form/Finance/Invoice/InvoiceForm'
import { InvoiceMutationDto, InvoiceStatus } from '../../../config/finance/invoiceConfig'
import { formatIsoDate } from '../../../helpers/dateHelper'

export const defaultInvoiceValues: InvoiceMutationDto = {
    type: undefined,
    templateId: undefined,
    children: undefined,
    status: InvoiceStatus.New,
    fileId: undefined,
    clientPivotId: undefined,
    debtorPivotId: undefined,
    number: undefined,
    name: '',
    description: undefined,
    date: formatIsoDate(new Date()),
    term: 0,
    lineItemGroups: [],
    language: undefined,
    currency: undefined,
    messageSubject: undefined,
    messageBody: undefined,
    unit: undefined, // The initial unit is dependent on the default unit of the file.
}

export default function AddInvoice(): ReactElement {
    return (
        <InvoiceForm
            formikProps={{
                initialValues: defaultInvoiceValues,
                onSubmit: () => {
                    return Promise.resolve({
                        url: '/finance/invoice',
                        method: 'POST',
                    })
                },
            }}
        />
    )
}
